import validate from "/builds/ldseating/ldseating-frontend/node_modules/.pnpm/nuxt@3.19.3_@parcel+watcher@2.5.1_@types+node@18.19.130_@vue+compiler-sfc@3.5.22_db0@0.3.4_es_megpm3yjphkhrswrqqruk3wvse/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45redirect_45lang_45global from "/builds/ldseating/ldseating-frontend/middleware/01.redirectLang.global.ts";
import auth_45global from "/builds/ldseating/ldseating-frontend/middleware/auth.global.ts";
import redirect_45global from "/builds/ldseating/ldseating-frontend/middleware/redirect.global.ts";
import resolve_45domain_45global from "/builds/ldseating/ldseating-frontend/middleware/resolveDomain.global.ts";
import manifest_45route_45rule from "/builds/ldseating/ldseating-frontend/node_modules/.pnpm/nuxt@3.19.3_@parcel+watcher@2.5.1_@types+node@18.19.130_@vue+compiler-sfc@3.5.22_db0@0.3.4_es_megpm3yjphkhrswrqqruk3wvse/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45redirect_45lang_45global,
  auth_45global,
  redirect_45global,
  resolve_45domain_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  node: () => import("/builds/ldseating/ldseating-frontend/middleware/node.ts")
}